export default {
    path: '/finance',
    redirect: '/finance/payment/list',
    meta: {
        title: "财务部",
        permissionCode:"pcFinance",
       
        
    },
    children: [
        {
            path: 'payment/list',
            name: 'financePaymentList',
            component: () => import("@/views/finance/payment/list/index.vue"),
            meta: {
                permissionCode: "pcFinancePaymentList",
                title: '项目付款确认',
            },  
        }, 
        {
            path: 'billing/list',
            name: 'financeBillingList',
            component: () => import("@/views/finance/billing/list.vue"),
            meta: {
                permissionCode: "pcFinanceBillingList",
                title: '项目开票登记',
                keepAlive:true
            },  
        },
        {
            path: 'loan/list',
            name: 'financeLoanList',
            component: () => import("@/views/finance/loan/list.vue"),
            meta: {
                permissionCode: "pcFinanceLoanList",
                title: '项目借款确认',
                keepAlive:true
            
                
            },  
        }, 
        {
            path: 'collectMoney/list',
            name: 'collectMoneyList',
            component: () => import("@/views/finance/collectMoney/list.vue"),
            meta: {
                permissionCode: "pcFinanceCollectMoneyList",
                title: '项目收款确认',
                keepAlive:true
            },  
        }, 
        {
            path: 'report/teamloan/list',
            name: 'teamloanList',
            component: () => import("@/views/finance/report/teamloan/list.vue"),
            meta: {
                permissionCode: "pcFinanceReportTeamLoanList",
                title: '班组借支表',
            },  
        }, 
        {
            path: 'report/singleMaterial/list',
            name: 'singleMaterialList',
            component: () => import("@/views/finance/report/singleMaterial/list.vue"),
            meta: {
                permissionCode: "pcFinanceReportSingleMaterialList",
                title: '单包材料汇总表',
            },  
        }, 
        {
            path: 'report/singleMaterial/detail',
            name: 'singleMaterialDetail',
            component: () => import("@/views/finance/report/singleMaterial/detail.vue"),
            meta: {
                permissionCode: "pcFinanceReportSingleMaterialDetail",
                title: '单包材料汇总表详情',
            },  
        }, 
        {
            path: 'report/supplierPayment/list',
            name: 'supplierPaymentList',
            component: () => import("@/views/finance/report/supplierPayment/list.vue"),
            meta: {
                permissionCode: "pcFinanceReportSupplierPaymentList",
                title: '供应商付款汇总表',
            },  
        }, 
        {
            path: 'report/supplierPayment/detail',
            name: 'supplierPaymentDetail',
            component: () => import("@/views/finance/report/supplierPayment/detail.vue"),
            meta: {
                permissionCode: "pcFinanceReportSupplierPaymentDetail",
                title: '供应商付款汇总表详情',
            },  
        }, 
    ]
}